import { cn } from '@/lib/utils'

// The Etainabl "A" at rest — the same two-bar shape EtainablSpinner animates,
// held still at badge size (.etn-mark in globals.css). The mark is drawn 50
// units tall, so the scale is the requested pixel height over 50.
const MARK_HEIGHT = 50

export function EtainablMark({ height = 11, className }: { height?: number; className?: string }) {
  return (
    <span
      className={cn('etn-mark', className)}
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      style={{ ['--etn-mark-scale' as any]: height / MARK_HEIGHT }}
      aria-hidden="true"
    >
      <span className="left" />
      <span className="right" />
    </span>
  )
}

// "ETAINABL" in the accent pill, mark first. Names us on the client-facing
// tracker surfaces, where "STAFF" says nothing to the client reading it. The
// BAU ticket thread keeps its own STAFF badge.
export function EtainablBadge({ className }: { className?: string }) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-[5px] rounded-etn-pill bg-etn-accent-tint px-[7px] py-0.5 text-[9px] font-bold tracking-[0.06em] text-etn-accent-text-active',
        className,
      )}
      data-testid="etainabl-badge"
    >
      <EtainablMark />
      ETAINABL
    </span>
  )
}
